const translations = {
    loadError: 'This user could not be loaded.',
    notFoundDescription: 'This user is no longer part of the organization.',
    notFoundHeading: 'User not found'
};

export default translations;
